"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const styled_components_1 = __importStar(require("styled-components"));
const StyledInput = styled_components_1.default.input `
  font-size: 16px;
  line-height: 1.38;
  border-radius: 4px;
  margin: 8px 0px 8px 0px;
  position: absolute;
  height: 40px;
  background: ${tokens.ColorWhite000};
  border: 1px solid ${tokens.ColorGrey500};
  text-align: ${props => (props.textAlign ? props.textAlign : "left")};
  :focus {
    border: 1px solid ${tokens.ColorChartingBlue100};
    outline: none;
    color: ${tokens.ColorGrey900};
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${tokens.ColorGrey600};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${tokens.ColorGrey600};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${tokens.ColorGrey600};
  }
  :disabled {
    background-color: ${tokens.ColorWhite075};
    border: solid 1px ${tokens.ColorWhite200};
  }
  @media only screen and (max-width: 768px) {
    height: 48px;
  }
  ${(props) => {
    let right = "16px ", left = "16px ";
    const top = "0px ", bottom = "0px ";
    if (props.leadingCharacter) {
        left = "32px ";
    }
    if (props.trailingCharacter) {
        right = props.trailingCharacterWidth + 24 + "px ";
    }
    if (props.trailingIcon) {
        right = "32px ";
    }
    return styled_components_1.css `
      padding: ${top + right + bottom + left};
      width: 100%;
    `;
}};
  ${(props) => {
    return ((props.errorMessage || props.hasError) &&
        styled_components_1.css `
        border: 1px solid ${tokens.ColorFunctionalRed700};
        color: ${tokens.ColorFunctionalRed700};
        :focus {
          border: 1px solid ${tokens.ColorFunctionalRed700};
          outline: none;
        }
      `);
}}
`;
const StyledInputContainer = styled_components_1.default.div `
  position: relative;
  height: 56px;
  font-family: Nimbus Sans Regular;
  width: 100%;
  color: ${tokens.ColorGrey900};
  @media only screen and (max-width: 768px) {
    height: 64px;
  }
`;
const StyledError = styled_components_1.default.div `
  font-size: 14px;
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorFunctionalRed700};
  width: 100%;
  margin-bottom: 8px;
`;
const StyledHelperText = styled_components_1.default.div `
  font-size: 14px;
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorGrey600};
  width: 100%;
  margin-bottom: 8px;
`;
const StyledLabel = styled_components_1.default.div `
  font-family: "Nimbus Sans Regular";
  color: ${tokens.ColorGrey900};
`;
const StyledTrailingIcon = styled_components_1.default.img `
  z-index: 2;
  position: absolute;
  right: 0px;
  top: 10px;
  margin: 8px 8px 8px 8px;
  @media only screen and (max-width: 768px) {
    margin: 11px 8px 11px 8px;
  }
`;
const StyledLeadingCharacter = styled_components_1.default.div `
  position: absolute;
  z-index: 2;
  margin: 8px 8px 8px 16px;
  top: 10px;
  color: ${tokens.ColorGrey600};
  @media only screen and (max-width: 768px) {
    margin: 12px 8px 12px 16px;
  }
`;
const StyledTrailingCharacter = styled_components_1.default.div `
  position: absolute;
  z-index: 2;
  margin: 8px 16px 8px 8px;
  top: 10px;
  right: 0;
  color: ${tokens.ColorGrey600};
  @media only screen and (max-width: 768px) {
    margin: 12px 16px 12px 8px;
  }
`;
class Input extends react_1.Component {
    render() {
        return react_1.default.createElement(StyledInput, Object.assign({}, this.props, { autocomplete: "off" }));
    }
}
exports.Input = Input;
class InputContainer extends react_1.Component {
    constructor(props) {
        super(props);
        this.trailingChar = null;
        this.state = {
            trailingCharacterWidth: 0
        };
    }
    componentDidMount() {
        this.setState({
            trailingCharacterWidth: this.trailingChar
                ? this.trailingChar.clientWidth
                : 0
        });
    }
    render() {
        const { leadingCharacter, trailingCharacter, trailingIcon, errorMessage, name } = this.props;
        return (react_1.default.createElement(StyledInputContainer, null,
            leadingCharacter && (react_1.default.createElement(StyledLeadingCharacter, null, leadingCharacter)),
            react_1.default.createElement(Input, Object.assign({}, this.props, { trailingCharacterWidth: this.state.trailingCharacterWidth })),
            trailingCharacter && (react_1.default.createElement(StyledTrailingCharacter, { ref: (element) => {
                    this.trailingChar = element;
                } }, trailingCharacter)),
            errorMessage && trailingIcon && (react_1.default.createElement(StyledTrailingIcon, { src: `data:image/svg+xml;base64,${tokens.AssetIconAlertCircleOutline}`, alt: "Icon for off track" }))));
    }
}
class InputWrapper extends react_1.Component {
    render() {
        const { label, errorMessage, helperText, width = "280px", marginLeftPx, marginRightPx } = this.props;
        return (react_1.default.createElement("div", { style: {
                width,
                display: "inline-block",
                marginLeft: marginLeftPx,
                marginRight: marginRightPx
            } },
            label && react_1.default.createElement(StyledLabel, null, label),
            react_1.default.createElement(InputContainer, Object.assign({}, this.props)),
            errorMessage && react_1.default.createElement(StyledError, null, errorMessage),
            helperText && !errorMessage && (react_1.default.createElement(StyledHelperText, null, helperText))));
    }
}
exports.default = InputWrapper;
//# sourceMappingURL=Input.js.map